module.exports = "/_next/static/images/8ef780839fb77428508b682127e43b08-rates-icon-new.svg";